<div class="mb-3">
  <app-field-title [titleInfo]="inputContent" [formControlObj]="formControlObj">
    <div class="input-group clockpicker">
      <input bsDatepicker class="form-control" autoClose="false" [formControl]="formControlObj"
        [placeholder]="isOptionLoading ? 'Loading..' : datePlaceholder" [bsConfig]="bsConfig"
        (bsValueChange)="onDateChange($event)">
    </div>
  </app-field-title>
</div>